/**
 * Blog post titles may mark a 1–3 word accent with a single-asterisk pair, e.g.
 * `Почему работодатели *не отвечают* на резюме` — rendered as the Playfair-italic
 * brand accent in the H1 (the site's premium signature). This is a rendering
 * convention over the plain `title` string, not a new frontmatter field, so the
 * merged `blog_posts` schema is untouched. `stripTitleEmphasis` is the pure
 * plain-text form used for `<title>`, meta, JSON-LD and breadcrumbs.
 */
const EMPHASIS_RE = /\*([^*]+)\*/;

export function stripTitleEmphasis(title: string): string {
  return title.replace(/\*([^*]+)\*/g, "$1");
}

export function parseTitleEmphasis(title: string): {
  before: string;
  accent: string | null;
  after: string;
} {
  const match = title.match(EMPHASIS_RE);
  if (!match || match.index === undefined) {
    return { before: title, accent: null, after: "" };
  }
  return {
    before: title.slice(0, match.index),
    accent: match[1],
    after: title.slice(match.index + match[0].length),
  };
}
